import { trpc } from '@/shared/api/trpc';

const useInvalidateOrg = () => {
  const utils = trpc.useUtils();
  return (id: string) => {
    utils.organizations.findOne.invalidate({ id });
    utils.auth.me.invalidate();
  };
};

/** Assign this organization's own Axus account (encrypted server-side). */
export const useSetAxusCredentials = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.setAxusCredentials.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

/** Remove the org's own Axus account. TempoVIP falls back to the platform one. */
export const useClearAxusCredentials = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.clearAxusCredentials.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

/**
 * System users only: copy the TempoVIP (platform) Axus account into this
 * organization. The values are copied server-side and never reach the client.
 */
export const useCopyPlatformAxusCredentials = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.copyPlatformAxusCredentials.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};
